import { operators as o, common as c } from '@pendo/aggregations';

export function applyCustomSegment (
    segment: c.PipelineData[],
    segmentId?: string,
): c.PipelineSegment | c.PipelineData[] | undefined {
    if (
        !segmentId ||
        ['everyoneExcludingAnonymous', 'everyone', 'anonymousVisitorsOnly', 'blacklistOnly'].includes(segmentId)
    ) {
        return o.segment({
            pipeline: segment,
        });
    }

    return o.segment({
        compound: `${segmentId} && inlineSegment`,
        pipelines: {
            inlineSegment: segment,
        },
    });
}
